import { Scale, CheckCircle2 } from 'lucide-react';

/** UK B2B outreach rules — what professional staffing agencies follow. */
export const OUTREACH_RULES = [
  'Only contact care homes about legitimate staffing services (B2B).',
  'Identify Osabea clearly on every call and email.',
  'Honor "do not contact" immediately — tick the box on the lead record.',
  'Log every touch in Sales CRM (audit trail for ICO if asked).',
  'Calls: business numbers only; be polite; call 9am–5pm weekdays.',
  'Emails: include opt-out line (added automatically when sending from portal).',
  'No SMS/WhatsApp marketing until you have consent or Twilio/WABA set up.',
  'Delete or close lost leads you will not pursue (data minimisation).',
];

export default function SalesOutreachCompliance({ compact = false }) {
  if (compact) {
    return (
      <p className="text-xs text-slate-600">
        <Scale className="h-3 w-3 inline mr-1" />
        B2B outreach only · log every touch · honor opt-outs · ICO registered
      </p>
    );
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <p className="text-sm font-semibold flex items-center gap-2 text-slate-900">
        <Scale className="h-4 w-4" /> Legal outreach checklist (UK)
      </p>
      <ul className="mt-2 space-y-1.5 text-xs text-slate-700">
        {OUTREACH_RULES.map((rule) => (
          <li key={rule} className="flex gap-2">
            <CheckCircle2 className="h-3.5 w-3.5 text-green-600 flex-shrink-0 mt-0.5" />
            <span>{rule}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}